import styled from "@emotion/styled";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CalendarstarIcon,
  CellsIcon,
  DivideSignIcon,
  LayoutIcon,
  LocationIcon,
  PinIcon,
  PoundIcon,
  SearchListIcon,
} from "./assets";
import BadgeWrapper from "./prtnr/ui/BadgeType";
import ToolTip from "./prtnr/ui/ToolTip";
import VideoPlayer from "./prtnr/ui/VideoPlayer";
import { fetchVendorById } from "./redux/slices/VendorThunks";

const asRichText = (value) => ({
  __html: value || "",
});

export default function VendorProfile() {
  const dispatch = useDispatch();
  const storedUser = localStorage.getItem("vendor");
  const user = storedUser ? JSON.parse(storedUser) : null;

  const vendor = useSelector((state) => state.vendor.selectedVendor);

  useEffect(() => {
    if (user?.account_id) {
      dispatch(fetchVendorById(user.account_id));
    }
  }, [dispatch, user?.account_id]);

  return (
    <RootWrapperProfileone>
      <VendorProfileDetails>
        <Wrapper>
          <Row>
            <Col1>
              <Frame1389>
                <Image20 src={vendor?.website_thumbnail} />
              </Frame1389>
              <Frame77>
                <Logo_0001>
                  <BadgeWrapper badgeType={vendor?.vendor_badge} />

                  <ImageLogo
                    src={`${vendor?.compay_logo}`}
                    alt="Company Logo"
                  />
                </Logo_0001>
                <Frame78>
                  <Row_0001>
                    <Nesti>{vendor?.company_name}</Nesti>
                  </Row_0001>
                  <Frame86>
                    <Row_0002>
                      <Frame82>
                        <Type>Type:</Type>
                        <FixedReferralReward>
                          Fixed Referral Reward
                        </FixedReferralReward>
                      </Frame82>
                    </Row_0002>
                    <Row_0003>
                      <Frame82>
                        <Website>Website:</Website>
                        <HttpsNestiIo>
                          {vendor?.company_website_url}
                        </HttpsNestiIo>
                      </Frame82>
                    </Row_0003>
                  </Frame86>
                </Frame78>
              </Frame77>
              <Frame85>
                <AboutCompany>About Company</AboutCompany>
                <Addinfo>
                  <AdditionalInfo>
                    <NestiIsEnablingSalesMarketingTeamsToBuildInteractiveCustomerExperiencesAtScaleWithPersonalizedAiVideoDynamicLandingPagesAndConversationalExperiencesAnAiFirstGenerativeVideoPlatformThatEnablesSalesMarketingTeamsToDeliver1000SOfPersonalisedOutreachVideosOnDynamicBuyerLandingPagesAtScale
                      dangerouslySetInnerHTML={asRichText(vendor?.about)}
                      className="quill-content"
                    />
                  </AdditionalInfo>
                </Addinfo>
              </Frame85>
              {vendor?.trusted_by && vendor.trusted_by.length > 0 && (
                <Frame85>
                  <CeoMessage>Trusted By</CeoMessage>
                  <TrustedByContainer>
                    {vendor.trusted_by.map((logoUrl, index) => (
                      <TrustedByLogoWrapper key={index}>
                        <TrustedByLogo
                          src={logoUrl}
                          alt={`Trusted company ${index + 1}`}
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                        />
                      </TrustedByLogoWrapper>
                    ))}
                  </TrustedByContainer>
                </Frame85>
              )}
              <Frame85>
                <T>
                  <IdealClientProfile>Ideal Client Profile</IdealClientProfile>
                  <Addinfo>
                    <AdditionalInfo>
                      <NestiIsEnablingSalesMarketingTeamsToBuildInteractiveCustomerExperiencesAtScaleWithPersonalizedAiVideoDynamicLandingPagesAndConversationalExperiencesAnAiFirstGenerativeVideoPlatformThatEnablesSalesMarketingTeamsToDeliver1000SOfPersonalisedOutreachVideosOnDynamicBuyerLandingPagesAtScale
                        dangerouslySetInnerHTML={asRichText(
                          vendor?.ideal_profile
                        )}
                        className="quill-content"
                      />
                    </AdditionalInfo>
                  </Addinfo>
                  <Content>
                    <_1>
                      <Column1>
                        <Layout01 src={LayoutIcon} alt="icon" />
                        <Sector>Sector</Sector>
                      </Column1>
                      <OurClientsCanBeFromAnySectorButWeDoHaveALotOfSaaSClientsInParticular>
                        {vendor?.sector}
                      </OurClientsCanBeFromAnySectorButWeDoHaveALotOfSaaSClientsInParticular>
                    </_1>
                    <Contentdivider>
                      <Line1 />
                    </Contentdivider>
                    <_1>
                      <Column1>
                        <Cells src={CellsIcon} alt="icon" />
                        <Sector>Company Size</Sector>
                      </Column1>
                      <_150000
                        dangerouslySetInnerHTML={asRichText(
                          vendor?.company_size
                        )}
                        className="quill-content"
                      />
                    </_1>
                    <Contentdivider>
                      <Line1 />
                    </Contentdivider>
                    <_1>
                      <Column1>
                        <Location01 src={LocationIcon} alt="icon" />
                        <Sector>Location</Sector>
                      </Column1>
                      <UkUsa>{vendor?.locations}</UkUsa>
                    </_1>
                    <Contentdivider>
                      <Line1 />
                    </Contentdivider>
                    <_1>
                      <Column1>
                        <Pound src={PoundIcon} alt="icon" />
                        <Sector>Typical Budget</Sector>
                      </Column1>
                      <_150000
                        dangerouslySetInnerHTML={asRichText(
                          vendor?.typical_budget
                        )}
                        className="quill-content"
                      />
                    </_1>
                    <Contentdivider>
                      <Line1 />
                    </Contentdivider>
                    <_1>
                      <Column1>
                        <DivideSign src={DivideSignIcon} alt="icon" />
                        <Sector>Typical Decision Maker</Sector>
                      </Column1>
                      <HeadsOfMarketingHeadsOfSales>
                        {vendor?.typical_decision_maker}
                      </HeadsOfMarketingHeadsOfSales>
                    </_1>
                    <Contentdivider>
                      <Line1 />
                    </Contentdivider>
                    <_1>
                      <Column1>
                        <SearchList01 src={SearchListIcon} alt="icon" />
                        <Sector>Typical Scenario</Sector>
                      </Column1>
                      <WeTypicallyHelpOurClientsWithProspectingNewClientsAndIncreasingSalesPipeline
                        dangerouslySetInnerHTML={asRichText(
                          vendor?.typical_scenario
                        )}
                        className="quill-content"
                      />
                    </_1>
                    <Contentdivider>
                      <Line1 />
                    </Contentdivider>
                    <_1>
                      <Column1>
                        <Pin src={PinIcon} alt="icon" />
                        <Sector>Typical Pain Points</Sector>
                      </Column1>
                      <OurClientsTypicallyDesireNewToolsToHelpThemGenerateSalesPipelineAndReachTheirProspectsInInnovativeInteractiveAndPersonalisedWays
                        dangerouslySetInnerHTML={asRichText(
                          vendor?.typical_pain_points
                        )}
                      />
                    </_1>
                    <Contentdivider>
                      <Line1 />
                    </Contentdivider>
                    <_1>
                      <Column1>
                        <Pin src={CalendarstarIcon} alt="icon" />
                        <TypicalDealCycle>Typical Deal Cycle</TypicalDealCycle>
                        <ToolTip
                          message={
                            "  Length of average deal cycle, from first contact to contract signing"
                          }
                        />
                      </Column1>
                      <_2Months>
                        {" "}
                        {vendor?.average_sales_cycle_in_months}
                      </_2Months>
                    </_1>
                  </Content>
                </T>
              </Frame85>
              <Frame85>
                <CeoMessage>Vendor Message to Members</CeoMessage>
                <Testimonialmain>
                  <Body>
                    <NestiHelpsDemandGenerationTeamsCreateTrulyPersonalisedDigitalExperiencesAtScaleThatGenerateWarmLeadsForSalesInsteadOfGenericOutreachYouCanNowDeliverTrulyPersonalisedVideoExperiencesForEveryProspectWeDLoveYouToMakeAReferralToUsViaPartnerAndWeLlPromiseToRollOutTheRedCarpetForYourFriendEnsuringAGreatClientExperience
                      dangerouslySetInnerHTML={asRichText(vendor?.message)}
                      className="quill-content"
                    />
                  </Body>
                  <Namewithavatar>
                    <img
                      src={vendor?.picture}
                      alt="Profile"
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "32px",
                        objectFit: "cover",
                      }}
                    />
                    <Top>
                      <MorganEdmondson>{vendor?.ceo_name}</MorganEdmondson>
                    </Top>
                  </Namewithavatar>
                </Testimonialmain>
              </Frame85>
            </Col1>
            <Col2>
              <Frame76>
                <Frame1542 />
                <Frame1543>
                  <Reward>Reward</Reward>
                  <_900>
                    £{Number(vendor?.reward)?.toLocaleString("en-GB")}
                  </_900>
                  <FixedReferralReward_0001>
                    Fixed Referral Reward
                  </FixedReferralReward_0001>
                </Frame1543>
              </Frame76>
              <Faqs>
                <WhenWillIGetPaidMyFixedReferralRewardAsSoonAsReferredClientContractIsSigned>
                  When will I get paid my Fixed Referral Reward?
                  <br />
                  <span style={{ color: "rgba(153, 160, 174, 1)" }}>
                    Typically within 30 days of a vendor successfully signing a
                    contract with the referred client.
                  </span>
                </WhenWillIGetPaidMyFixedReferralRewardAsSoonAsReferredClientContractIsSigned>
                <Contentdivider_0007>
                  <Line1_0007 />
                </Contentdivider_0007>
                <HowWillIGetPaidMyFixedReferralRewardStraightIntoYourBankAccount>
                  How will I get paid my Fixed Referral Reward?
                  <br />
                  <span style={{ color: "rgba(153, 160, 174, 1)" }}>
                    Rewards can be paid directly into your chosen bank account.
                    Alternatively, you may decide to donate to one of our chosen
                    charities.
                  </span>
                </HowWillIGetPaidMyFixedReferralRewardStraightIntoYourBankAccount>
                <Contentdivider_0007>
                  <Line1_0007 />
                </Contentdivider_0007>
                <TrackedInTypicallyLessThan24Hours>
                  How soon will I be able to see the vendor's progress with my
                  referral?
                  <br />
                  <span style={{ color: "rgba(153, 160, 174, 1)" }}>
                    Typically, less than 24 hours.
                  </span>
                </TrackedInTypicallyLessThan24Hours>
              </Faqs>
              {vendor?.video_url && (
                <Frame85>
                  <VideoPlayer videoUrl={vendor?.video_url} />
                  <IntroducingBy>
                    Introducing: {vendor?.company_name}
                  </IntroducingBy>
                </Frame85>
              )}
              <Frame85>
                <Addinfo>
                  <AdditionalInfo>
                    <NumberOfEmployees110>
                      Number of Employees: {vendor?.no_of_employees}
                    </NumberOfEmployees110>
                    <Contentdivider_0007>
                      <Line1 />
                    </Contentdivider_0007>
                    <HqBristolUk>HQ: {vendor?.vendor_hq}</HqBristolUk>
                    <Contentdivider_0007>
                      <Line1 />
                    </Contentdivider_0007>
                    <Founded2021>Founded: {vendor?.year_founded}</Founded2021>
                  </AdditionalInfo>
                </Addinfo>
              </Frame85>
            </Col2>
          </Row>
        </Wrapper>
      </VendorProfileDetails>
    </RootWrapperProfileone>
  );
}

const RootWrapperProfileone = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
`;

const VendorProfileDetails = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;

  padding-inline: clamp(1rem, 5vw, 3.75rem);

  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
`;

const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 24px 0px;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Col1 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 32px;
  border-radius: 16px;
  width: 848px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame1389 = styled.div`
  max-height: 297px;
  overflow: hidden;
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 16px;
  position: relative;
  align-self: stretch;
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Image20 = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const Frame77 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  @media (max-width: 1024px) and (min-width: 768px) {
    flex-direction: column;
  }

  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

const Logo_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  box-shadow: 0px 7px 30px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
  width: 260px;
  height: 150px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px 3.44px;
  position: relative;
  @media (max-width: 1024px) and (min-width: 768px) {
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;
const ImageLogo = styled.img`
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  object-fit: contain;
  display: block;
`;

const Frame78 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 16px;
  border-radius: 16px;
  width: 564px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Row_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Nesti = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: clamp(1.5rem, 5vw, 3rem);
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -1px;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame86 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Row_0002 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  border-top: solid 1px rgba(136, 136, 136, 0.1);
  border-bottom: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Frame82 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: 1;
  gap: 8px;
  width: 500px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Type = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const FixedReferralReward = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 457px;
  flex: 1;
`;

const Row_0003 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const Website = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const HttpsNestiIo = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 430px;
  flex: 1;
`;

const Frame85 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const AboutCompany = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Addinfo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px 16px;
  flex-shrink: 0;
`;

const AdditionalInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const NestiIsEnablingSalesMarketingTeamsToBuildInteractiveCustomerExperiencesAtScaleWithPersonalizedAiVideoDynamicLandingPagesAndConversationalExperiencesAnAiFirstGenerativeVideoPlatformThatEnablesSalesMarketingTeamsToDeliver1000SOfPersonalisedOutreachVideosOnDynamicBuyerLandingPagesAtScale = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const T = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const IdealClientProfile = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Content = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const _1 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

const Column1 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  flex: none;
  gap: 8px;
  width: 250px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Layout01 = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const Sector = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const OurClientsCanBeFromAnySectorButWeDoHaveALotOfSaaSClientsInParticular = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 434px;
  flex: 1;
`;

const Contentdivider = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Line1 = styled.div`
  height: 0px;
  border-top: solid 1px rgb(225, 228, 234);
  align-self: stretch;
  flex-shrink: 0;
`;

const Cells = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const _150000 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 436px;
  flex: 1;
`;

const Location01 = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const UkUsa = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 436px;
  flex: 1;
`;

const Pound = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const DivideSign = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const HeadsOfMarketingHeadsOfSales = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 434px;
  flex: 1;
`;

const SearchList01 = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const WeTypicallyHelpOurClientsWithProspectingNewClientsAndIncreasingSalesPipeline = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  max-width: 434px;
  width: 100%;
  flex: 1;
`;

const Pin = styled.img`
  width: 24px;
  height: 24px;
  object-fit: cover;
`;

const OurClientsTypicallyDesireNewToolsToHelpThemGenerateSalesPipelineAndReachTheirProspectsInInnovativeInteractiveAndPersonalisedWays = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 434px;
  flex: 1;
`;

const TypicalDealCycle = styled.span`
  color: rgb(100, 116, 139);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const _2Months = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  width: 436px;
  flex: 1;
`;

const CeoMessage = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 20px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  line-height: 160%;
  text-align: left;
  min-height: 29px;
  align-self: stretch;
  flex-shrink: 0;
`;

const Testimonialmain = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  box-shadow: 0px 3px 2px rgba(132, 38, 232, 0.03);
  border: solid 1px rgba(136, 136, 136, 0.1);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 24px;
  flex-shrink: 0;
`;

const Body = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const NestiHelpsDemandGenerationTeamsCreateTrulyPersonalisedDigitalExperiencesAtScaleThatGenerateWarmLeadsForSalesInsteadOfGenericOutreachYouCanNowDeliverTrulyPersonalisedVideoExperiencesForEveryProspectWeDLoveYouToMakeAReferralToUsViaPartnerAndWeLlPromiseToRollOutTheRedCarpetForYourFriendEnsuringAGreatClientExperience = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
  font-style: italic;
`;

const Namewithavatar = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Top = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const MorganEdmondson = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
`;

const Col2 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 24px;
  width: 320px;
  box-sizing: border-box;
  @media (max-width: 1024px) and (min-width: 768px) {
    width: 100%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }
`;

const Frame76 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  border-radius: 16px;
  align-self: stretch;
  background: radial-gradient(rgb(212, 242, 255), rgb(136, 204, 235));
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 0px 0px 32px;
  flex-shrink: 0;
`;

const Frame1542 = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  padding: 8px;
  flex-shrink: 0;
`;

const Frame1543 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  flex: none;
  gap: 11px;
  width: 273px;
  box-sizing: border-box;
`;

const Reward = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const _900 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 68px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  letter-spacing: -2px;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const FixedReferralReward_0001 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Faqs = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(33, 37, 67);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 16px;
  flex-shrink: 0;
`;

const IntroducingBy = styled.div`
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: flex-start;
  font-family: Montserrat, sans-serif;

  width: 100%;
`;

const WhenWillIGetPaidMyFixedReferralRewardAsSoonAsReferredClientContractIsSigned = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Contentdivider_0007 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Line1_0007 = styled.div`
  height: 0px;
  border-top: solid 1px rgba(136, 136, 136, 0.1);
  align-self: stretch;
  flex-shrink: 0;
`;

const HowWillIGetPaidMyFixedReferralRewardStraightIntoYourBankAccount = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const TrackedInTypicallyLessThan24Hours = styled.span`
  color: white;
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const NumberOfEmployees110 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const HqBristolUk = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const Founded2021 = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: left;
  align-self: stretch;
  flex-shrink: 0;
`;

const TrustedByContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 24px;
  align-items: center;
  justify-items: center;
  box-shadow: 0px 1px 2px rgba(10, 13, 20, 0.03);
  border: solid 1px rgb(225, 228, 234);
  border-radius: 16px;
  align-self: stretch;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 32px 24px;
  flex-shrink: 0;

  @media (max-width: 1024px) and (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    padding: 24px 16px;
  }
`;

const TrustedByLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
  box-sizing: border-box;
  border: solid 1px rgb(225, 228, 234);
  border-radius: 8px;
  padding: 6px;

  @media (max-width: 767px) {
    height: 60px;
    padding: 4px;
  }
`;

const TrustedByLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
